import React from 'react';
import Inputs from 'components/inputs/inputs';
import Panel from 'components/common/panel/panel';
import { Tabs, Tab } from 'components/common/tabs/tabs';
import { ShowNotifyPopup } from 'components/common/popup/popup';
import Divider from 'components/common/divider/divider';
import Spinner from 'components/common/spinner/spinner';
import Heading from 'components/common/heading/heading';
import Color from 'utils/color';

export default function ComponentTestPage(props) {
  const ShowNotify = (title, variant) => {
    ShowNotifyPopup({
      title: title,
      message: 'Awesome you successfully read this important alert message',
      variant: variant,
      yPosition: 'bottom',
      xPosition: 'center',
      seconds: 5,
    });
  };

  return (
    <>
      <Heading>
        <div>
          <div className='btn btn-none text-dark text-thick'>Components Test</div>
          <a href='/Developers/Test/Data' className='btn btn-link'>View Data Test</a>
          <a href='/Developers/Test/Forms' className='btn btn-link'>View Forms Test</a>
          <a href='/Developers/Test/Modals' className='btn btn-link'>View Modals Test</a>
        </div>
      </Heading>

      <div className='row justify-content-center mx-0 mt-4'>
        <div className='col-md-10 col-lg-9 col-xl-7'>

          <Panel>
            <Panel.Header>Text</Panel.Header>
            <Panel.Body>
              <div className='row'>
                <div className='col-3'>
                  <div>Normal</div>
                  <h1>H1</h1>
                  <h2>H2</h2>
                  <h3>H3</h3>
                  <h4>H4</h4>
                  <h5>H5</h5>
                </div>
                <div className='col-3'>
                  <div className='text-thin'>Thin</div>
                  <h1 className='text-thin'>H1</h1>
                  <h2 className='text-thin'>H2</h2>
                  <h3 className='text-thin'>H3</h3>
                  <h4 className='text-thin'>H4</h4>
                  <h5 className='text-thin'>H5</h5>
                </div>
                <div className='col-3'>
                  <div className='text-thick'>Thick</div>
                  <h1 className='text-thick'>H1</h1>
                  <h2 className='text-thick'>H2</h2>
                  <h3 className='text-thick'>H3</h3>
                  <h4 className='text-thick'>H4</h4>
                  <h5 className='text-thick'>H5</h5>
                </div>
                <div className='col-3'>
                  <div className='text-thicker'>Thicker</div>
                  <h1 className='text-thicker'>H1</h1>
                  <h2 className='text-thicker'>H2</h2>
                  <h3 className='text-thicker'>H3</h3>
                  <h4 className='text-thicker'>H4</h4>
                  <h5 className='text-thicker'>H5</h5>
                </div>
              </div>
              <div className='mt-2'>
                &nbsp;<span>Normal</span>
                &nbsp;<span className='text-app'>App</span>
                &nbsp;<span className='text-success'>Success</span>
                &nbsp;<span className='text-danger'>Danger</span>
                &nbsp;<span className='text-warning'>Warning</span>
                &nbsp;<span className='text-info'>Info</span>
                &nbsp;<span className='text-primary'>Primary</span>
                &nbsp;<span className='text-secondary'>Secondary</span>
                &nbsp;<span className='text-default'>Default</span>
                &nbsp;<span className='text-light bg-default'>Light</span>
                &nbsp;<span className='text-white bg-default'>White</span>
                &nbsp;<span className='text-dark'>Dark</span>
                &nbsp;<span className='text-black'>Black</span>
                &nbsp;<span className='text-gray'>Gray</span>
                &nbsp;<span className='text-link'>Link</span>
              </div>
              <div className='mt-2'>
                &nbsp;<span style={{ color: Color.defaults.text }}>Normal</span>
                &nbsp;<span style={{ color: Color.defaults.app }}>App</span>
                &nbsp;<span style={{ color: Color.defaults.success }}>Success</span>
                &nbsp;<span style={{ color: Color.defaults.danger }}>Danger</span>
                &nbsp;<span style={{ color: Color.defaults.warning }}>Warning</span>
                &nbsp;<span style={{ color: Color.defaults.info }}>Info</span>
                &nbsp;<span style={{ color: Color.defaults.primary }}>Primary</span>
                &nbsp;<span style={{ color: Color.defaults.secondary }}>Secondary</span>
                &nbsp;<span style={{ color: Color.defaults.default }}>Default</span>
                &nbsp;<span style={{ color: Color.defaults.light }} className='bg-default'>Light</span>
                &nbsp;<span style={{ color: Color.defaults.white }} className='bg-default'>White</span>
                &nbsp;<span style={{ color: Color.defaults.dark }}>Dark</span>
                &nbsp;<span style={{ color: Color.defaults.black }}>Black</span>
                &nbsp;<span style={{ color: Color.defaults.gray }}>Gray</span>
                &nbsp;<span style={{ color: Color.defaults.link }}>Link</span>
              </div>
              <div>
                <Divider text='Divider Large' size='lg' />
                <Divider text='Divider Medium' />
                <Divider text='Divider Small' size='sm' />

                <Divider text='Divider Left' position='left' />
                <Divider text='Divider Right' position='right' />
                <Divider text='Divider Center' />
              </div>
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Background and Border</Panel.Header>
            <Panel.Body>
              <h4>Background Normal</h4>
              <div className='row mx-0'>
                <div className='col-12 p-1 my-1'>Normal</div>
                <div className='col-6 p-1 my-1 text-white bg-app'>App</div>
                <div className='col-6 p-1 my-1 text-white' style={{ backgroundColor: Color.defaults.app }}></div>
                <div className='col-6 p-1 my-1 text-white bg-success'>Success</div>
                <div className='col-6 p-1 my-1 text-white' style={{ backgroundColor: Color.defaults.success }}></div>
                <div className='col-6 p-1 my-1 text-white bg-danger'>Danger</div>
                <div className='col-6 p-1 my-1 text-white' style={{ backgroundColor: Color.defaults.danger }}></div>
                <div className='col-6 p-1 my-1 text-white bg-warning'>Warning</div>
                <div className='col-6 p-1 my-1 text-white' style={{ backgroundColor: Color.defaults.warning }}></div>
                <div className='col-6 p-1 my-1 text-white bg-info'>Info</div>
                <div className='col-6 p-1 my-1 text-white' style={{ backgroundColor: Color.defaults.info }}></div>
                <div className='col-6 p-1 my-1 text-white bg-primary'>Primary</div>
                <div className='col-6 p-1 my-1 text-white' style={{ backgroundColor: Color.defaults.primary }}></div>
                <div className='col-6 p-1 my-1 text-white bg-secondary'>Secondary</div>
                <div className='col-6 p-1 my-1 text-white' style={{ backgroundColor: Color.defaults.secondary }}></div>
                <div className='col-6 p-1 my-1 text-black bg-default'>Default</div>
                <div className='col-6 p-1 my-1 text-black' style={{ backgroundColor: Color.defaults.default }}></div>
                <div className='col-6 p-1 my-1 text-black bg-light'>Light</div>
                <div className='col-6 p-1 my-1 text-black' style={{ backgroundColor: Color.defaults.light }}></div>
                <div className='col-6 p-1 my-1 text-white bg-dark'>Dark</div>
                <div className='col-6 p-1 my-1 text-white' style={{ backgroundColor: Color.defaults.dark }}></div>
                <div className='col-6 p-1 my-1 text-white bg-text'>Text</div>
                <div className='col-6 p-1 my-1 text-white' style={{ backgroundColor: Color.defaults.text }}></div>
              </div>
            </Panel.Body>
            <Panel.Body>
              <h4>Background Light</h4>
              <div className='mt-3'>
                <div className='p-1 my-1'>Normal</div>
                <div className='p-1 my-1 bg-light-app'>App</div>
                <div className='p-1 my-1 bg-light-success'>Success</div>
                <div className='p-1 my-1 bg-light-danger'>Danger</div>
                <div className='p-1 my-1 bg-light-warning'>Warning</div>
                <div className='p-1 my-1 bg-light-info'>Info</div>
                <div className='p-1 my-1 bg-light-primary'>Primary</div>
                <div className='p-1 my-1 bg-light-secondary'>Secondary</div>
                <div className='p-1 my-1 bg-light-default'>Default</div>
              </div>
            </Panel.Body>
            <Panel.Body>
              <h4>Border Normal</h4>
              <div className='mt-3'>
                <div className='p-1 my-1'>Normal</div>
                <div className='p-1 my-1 border border-app'>App</div>
                <div className='p-1 my-1 border border-success'>Success</div>
                <div className='p-1 my-1 border border-danger'>Danger</div>
                <div className='p-1 my-1 border border-warning'>Warning</div>
                <div className='p-1 my-1 border border-info'>Info</div>
                <div className='p-1 my-1 border border-primary'>Primary</div>
                <div className='p-1 my-1 border border-secondary'>Secondary</div>
                <div className='p-1 my-1 border border-default'>Default</div>
                <div className='p-1 my-1 border border-light'>Light</div>
                <div className='p-1 my-1 border border-dark'>Dark</div>
                <div className='p-1 my-1 border border-text'>Text</div>
              </div>
            </Panel.Body>
            <Panel.Body>
              <h4>Border Light</h4>
              <div className='mt-3'>
                <div className='p-1 my-1'>Normal</div>
                <div className='p-1 my-1 border border-light-app'>App</div>
                <div className='p-1 my-1 border border-light-success'>Success</div>
                <div className='p-1 my-1 border border-light-danger'>Danger</div>
                <div className='p-1 my-1 border border-light-warning'>Warning</div>
                <div className='p-1 my-1 border border-light-info'>Info</div>
                <div className='p-1 my-1 border border-light-primary'>Primary</div>
                <div className='p-1 my-1 border border-light-secondary'>Secondary</div>
                <div className='p-1 my-1 border border-light-default'>Default</div>
              </div>
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Badges</Panel.Header>
            <Panel.Body>
              <h4>Normal</h4>
              &nbsp;<span className='badge'>Normal</span>
              &nbsp;<span className='badge badge-app'>App</span>
              &nbsp;<span className='badge badge-success'>Success</span>
              &nbsp;<span className='badge badge-danger'>Danger</span>
              &nbsp;<span className='badge badge-warning'>Warning</span>
              &nbsp;<span className='badge badge-info'>Info</span>
              &nbsp;<span className='badge badge-primary'>Primary</span>
              &nbsp;<span className='badge badge-secondary'>Secondary</span>
              &nbsp;<span className='badge badge-default'>Default</span>
              &nbsp;<span className='badge badge-app badge-pill'>Pill</span>
              &nbsp;<span className='badge badge-success badge-pill'>8</span>
            </Panel.Body>
            <Panel.Body>
              <h4>Large</h4>
              &nbsp;<span className='badge badge-lg'>Normal</span>
              &nbsp;<span className='badge badge-lg badge-app'>App</span>
              &nbsp;<span className='badge badge-lg badge-success'>Success</span>
              &nbsp;<span className='badge badge-lg badge-danger'>Danger</span>
              &nbsp;<span className='badge badge-lg badge-warning'>Warning</span>
              &nbsp;<span className='badge badge-lg badge-info'>Info</span>
              &nbsp;<span className='badge badge-lg badge-primary'>Primary</span>
              &nbsp;<span className='badge badge-lg badge-secondary'>Secondary</span>
              &nbsp;<span className='badge badge-lg badge-default'>Default</span>
              &nbsp;<span className='badge badge-lg badge-app badge-pill'>Pill</span>
              &nbsp;<span className='badge badge-lg badge-success badge-pill'>8</span>
            </Panel.Body>
            <Panel.Body>
              <h4>Small</h4>
              &nbsp;<span className='badge badge-sm'>Normal</span>
              &nbsp;<span className='badge badge-sm badge-app'>App</span>
              &nbsp;<span className='badge badge-sm badge-success'>Success</span>
              &nbsp;<span className='badge badge-sm badge-danger'>Danger</span>
              &nbsp;<span className='badge badge-sm badge-warning'>Warning</span>
              &nbsp;<span className='badge badge-sm badge-info'>Info</span>
              &nbsp;<span className='badge badge-sm badge-primary'>Primary</span>
              &nbsp;<span className='badge badge-sm badge-secondary'>Secondary</span>
              &nbsp;<span className='badge badge-sm badge-default'>Default</span>
              &nbsp;<span className='badge badge-sm badge-app badge-pill'>Pill</span>
              &nbsp;<span className='badge badge-sm badge-success badge-pill'>8</span>
            </Panel.Body>
            <Panel.Body>
              <h4>Mini</h4>
              &nbsp;<span className='badge badge-xs'>Normal</span>
              &nbsp;<span className='badge badge-xs badge-app'>App</span>
              &nbsp;<span className='badge badge-xs badge-success'>Success</span>
              &nbsp;<span className='badge badge-xs badge-danger'>Danger</span>
              &nbsp;<span className='badge badge-xs badge-warning'>Warning</span>
              &nbsp;<span className='badge badge-xs badge-info'>Info</span>
              &nbsp;<span className='badge badge-xs badge-primary'>Primary</span>
              &nbsp;<span className='badge badge-xs badge-secondary'>Secondary</span>
              &nbsp;<span className='badge badge-xs badge-default'>Default</span>
              &nbsp;<span className='badge badge-xs badge-app badge-pill'>Pill</span>
              &nbsp;<span className='badge badge-xs badge-success badge-pill'>8</span>
            </Panel.Body>
            <Panel.Body>
              <h4>Outline</h4>
              &nbsp;<span className='badge badge-outline'>Normal</span>
              &nbsp;<span className='badge badge-outline-app'>App</span>
              &nbsp;<span className='badge badge-outline-success'>Success</span>
              &nbsp;<span className='badge badge-outline-danger'>Danger</span>
              &nbsp;<span className='badge badge-outline-warning'>Warning</span>
              &nbsp;<span className='badge badge-outline-info'>Info</span>
              &nbsp;<span className='badge badge-outline-primary'>Primary</span>
              &nbsp;<span className='badge badge-outline-secondary'>Secondary</span>
              &nbsp;<span className='badge badge-outline-default'>Default</span>
              &nbsp;<span className='badge badge-outline-app badge-pill'>Pill</span>
              &nbsp;<span className='badge badge-outline-success badge-pill'>8</span>
            </Panel.Body>
            <Panel.Body>
              <h4>Light</h4>
              &nbsp;<span className='badge badge-light'>Normal</span>
              &nbsp;<span className='badge badge-light-app'>App</span>
              &nbsp;<span className='badge badge-light-success'>Success</span>
              &nbsp;<span className='badge badge-light-danger'>Danger</span>
              &nbsp;<span className='badge badge-light-warning'>Warning</span>
              &nbsp;<span className='badge badge-light-info'>Info</span>
              &nbsp;<span className='badge badge-light-primary'>Primary</span>
              &nbsp;<span className='badge badge-light-secondary'>Secondary</span>
              &nbsp;<span className='badge badge-light-default'>Default</span>
              &nbsp;<span className='badge badge-light-app badge-pill'>Pill</span>
              &nbsp;<span className='badge badge-light-success badge-pill'>8</span>
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Buttons</Panel.Header>
            <Panel.Body>
              <h4>Normal</h4>
              <Inputs.Button variant='app'>App</Inputs.Button>
              <Inputs.Button variant='success'>Success</Inputs.Button>
              <Inputs.Button variant='danger'>Danger</Inputs.Button>
              <Inputs.Button variant='warning'>Warning</Inputs.Button>
              <Inputs.Button variant='info'>Info</Inputs.Button>
              <Inputs.Button variant='primary'>Primary</Inputs.Button>
              <Inputs.Button variant='secondary'>Secondary</Inputs.Button>
              <Inputs.Button variant='default'>Default</Inputs.Button>
              <Inputs.Button variant='light'>Light</Inputs.Button>
              <Inputs.Button variant='dark'>Dark</Inputs.Button>
              <Inputs.Button variant='form'>Form</Inputs.Button>
              <Inputs.Button variant='link'>Link</Inputs.Button>
              <Inputs.Button variant='transparent'>Transparent</Inputs.Button>
              <Inputs.Button variant='none'>None</Inputs.Button>
              <Inputs.Button variant='app' block>Block</Inputs.Button>
            </Panel.Body>
            <Panel.Body>
              <h4>Large</h4>
              <Inputs.Button variant='app' size='lg'>App</Inputs.Button>
              <Inputs.Button variant='success' size='lg'>Success</Inputs.Button>
              <Inputs.Button variant='danger' size='lg'>Danger</Inputs.Button>
              <Inputs.Button variant='warning' size='lg'>Warning</Inputs.Button>
              <Inputs.Button variant='info' size='lg'>Info</Inputs.Button>
              <Inputs.Button variant='primary' size='lg'>Primary</Inputs.Button>
              <Inputs.Button variant='secondary' size='lg'>Secondary</Inputs.Button>
              <Inputs.Button variant='default' size='lg'>Default</Inputs.Button>
              <Inputs.Button variant='light' size='lg'>Light</Inputs.Button>
              <Inputs.Button variant='dark' size='lg'>Dark</Inputs.Button>
              <Inputs.Button variant='form' size='lg'>Form</Inputs.Button>
              <Inputs.Button variant='link' size='lg'>Link</Inputs.Button>
              <Inputs.Button variant='transparent' size='lg'>Transparent</Inputs.Button>
              <Inputs.Button variant='none' size='lg'>None</Inputs.Button>
              <Inputs.Button variant='app' size='lg' block>Block</Inputs.Button>
            </Panel.Body>
            <Panel.Body>
              <h4>Small</h4>
              <Inputs.Button variant='app' size='sm'>App</Inputs.Button>
              <Inputs.Button variant='success' size='sm'>Success</Inputs.Button>
              <Inputs.Button variant='danger' size='sm'>Danger</Inputs.Button>
              <Inputs.Button variant='warning' size='sm'>Warning</Inputs.Button>
              <Inputs.Button variant='info' size='sm'>Info</Inputs.Button>
              <Inputs.Button variant='primary' size='sm'>Primary</Inputs.Button>
              <Inputs.Button variant='secondary' size='sm'>Secondary</Inputs.Button>
              <Inputs.Button variant='default' size='sm'>Default</Inputs.Button>
              <Inputs.Button variant='light' size='sm'>Light</Inputs.Button>
              <Inputs.Button variant='dark' size='sm'>Dark</Inputs.Button>
              <Inputs.Button variant='form' size='sm'>Form</Inputs.Button>
              <Inputs.Button variant='link' size='sm'>Link</Inputs.Button>
              <Inputs.Button variant='transparent' size='sm'>Transparent</Inputs.Button>
              <Inputs.Button variant='none' size='sm'>None</Inputs.Button>
              <Inputs.Button variant='app' size='sm' block>Block</Inputs.Button>
            </Panel.Body>
            <Panel.Body>
              <h4>Mini</h4>
              <Inputs.Button variant='app' size='xs'>App</Inputs.Button>
              <Inputs.Button variant='success' size='xs'>Success</Inputs.Button>
              <Inputs.Button variant='danger' size='xs'>Danger</Inputs.Button>
              <Inputs.Button variant='warning' size='xs'>Warning</Inputs.Button>
              <Inputs.Button variant='info' size='xs'>Info</Inputs.Button>
              <Inputs.Button variant='primary' size='xs'>Primary</Inputs.Button>
              <Inputs.Button variant='secondary' size='xs'>Secondary</Inputs.Button>
              <Inputs.Button variant='default' size='xs'>Default</Inputs.Button>
              <Inputs.Button variant='light' size='xs'>Light</Inputs.Button>
              <Inputs.Button variant='dark' size='xs'>Dark</Inputs.Button>
              <Inputs.Button variant='form' size='xs'>Form</Inputs.Button>
              <Inputs.Button variant='link' size='xs'>Link</Inputs.Button>
              <Inputs.Button variant='transparent' size='xs'>Transparent</Inputs.Button>
              <Inputs.Button variant='none' size='xs'>None</Inputs.Button>
              <Inputs.Button variant='app' size='xs' block>Block</Inputs.Button>
            </Panel.Body>
            <Panel.Body>
              <h4>Disabled</h4>
              <Inputs.Button variant='app' disabled>App</Inputs.Button>
              <Inputs.Button variant='success' disabled>Success</Inputs.Button>
              <Inputs.Button variant='danger' disabled>Danger</Inputs.Button>
              <Inputs.Button variant='warning' disabled>Warning</Inputs.Button>
              <Inputs.Button variant='info' disabled>Info</Inputs.Button>
              <Inputs.Button variant='primary' disabled>Primary</Inputs.Button>
              <Inputs.Button variant='secondary' disabled>Secondary</Inputs.Button>
              <Inputs.Button variant='default' disabled>Default</Inputs.Button>
              <Inputs.Button variant='light' disabled>Light</Inputs.Button>
              <Inputs.Button variant='dark' disabled>Dark</Inputs.Button>
              <Inputs.Button variant='form' disabled>Form</Inputs.Button>
              <Inputs.Button variant='link' disabled>Link</Inputs.Button>
              <Inputs.Button variant='transparent' disabled>Transparent</Inputs.Button>
              <Inputs.Button variant='none' disabled>None</Inputs.Button>
              <Inputs.Button variant='app' disabled block>Block</Inputs.Button>
            </Panel.Body>
            <Panel.Body>
              <h4>Loading</h4>
              <Inputs.Button variant='app' size='lg' loading={true}></Inputs.Button>
              <Inputs.Button variant='app' loading={true}></Inputs.Button>
              <Inputs.Button variant='app' size='sm' loading={true}></Inputs.Button>
              <Inputs.Button variant='app' size='xs' loading={true}></Inputs.Button>
              <Inputs.Button variant='success' loading={true} loadingLabel='Action In Progress'></Inputs.Button>
              <Inputs.Button variant='danger' loading={true} loadingLabel='Canceling...'></Inputs.Button>
              <Inputs.Button variant='app' block loading={true} loadingLabel='Canceling...'></Inputs.Button>
            </Panel.Body>
            <Panel.Body>
              <h4>Icons</h4>
              <Inputs.Button variant='success'><i className='icons8-save' />Success</Inputs.Button>
              <Inputs.Button variant='danger' iconClass='icons8-trash' label='Danger' />
              <Inputs.Button variant='secondary' iconClass='icons8-calendar' />
              <Inputs.Button variant='link' iconClass='icons8-undo' />
              <Inputs.Button variant='app' block><i className='icons8-settings' />Block</Inputs.Button>
            </Panel.Body>
            <Panel.Body>
              <h4>Links</h4>
              <Inputs.Button variant='link' href='https://google.com'>Link</Inputs.Button>
              <Inputs.Button variant='default' href='https://google.com'>Link Default</Inputs.Button>
              <Inputs.Button variant='success' href='https://google.com' disabled>Link Disabled</Inputs.Button>
              <Inputs.Button variant='danger' href='https://google.com' loading={true}>Link Loading</Inputs.Button>
              <Inputs.Button variant='warning' href='https://google.com' onClick={() => null}>Link Broken</Inputs.Button>
              <Inputs.Button variant='app' block href='https://google.com'>Link Block</Inputs.Button>
            </Panel.Body>
            <Panel.Body>
              <h4>Hover</h4>
              <Inputs.Button variant='hover-app'>App</Inputs.Button>
              <Inputs.Button variant='hover-success'>Success</Inputs.Button>
              <Inputs.Button variant='hover-danger'>Danger</Inputs.Button>
              <Inputs.Button variant='hover-warning'>Warning</Inputs.Button>
              <Inputs.Button variant='hover-info'>Info</Inputs.Button>
              <Inputs.Button variant='hover-primary'>Primary</Inputs.Button>
              <Inputs.Button variant='hover-secondary'>Secondary</Inputs.Button>
              <Inputs.Button variant='hover-default'>Default</Inputs.Button>
              <Inputs.Button variant='hover-app' block>Block</Inputs.Button>
            </Panel.Body>
            <Panel.Body>
              <h4>Circle</h4>
              <Inputs.Button variant='default' iconClass='icons8-star' circle />
              <Inputs.Button variant='app' iconClass='icons8-checkmark' circle />
              <Inputs.Button variant='success' iconClass='icons8-save' circle />
              <Inputs.Button variant='danger' iconClass='icons8-trash' circle />
            </Panel.Body>
            <Panel.Body>
              <h4>Circle / Large</h4>
              <Inputs.Button variant='default' size='lg' iconClass='icons8-star' circle />
              <Inputs.Button variant='app' size='lg' iconClass='icons8-checkmark' circle />
              <Inputs.Button variant='success' size='lg' iconClass='icons8-save' circle />
              <Inputs.Button variant='danger' size='lg' iconClass='icons8-trash' circle />
            </Panel.Body>
            <Panel.Body>
              <h4>Group</h4>
              <div>
                <div className='btn-group'>
                  <Inputs.Button variant='default'>Default 1</Inputs.Button>
                  <Inputs.Button variant='default'>Default 2</Inputs.Button>
                </div>
              </div>
              <div className='mt-2'>
                <div className='btn-group'>
                  <Inputs.Button variant='default'>Default 1</Inputs.Button>
                  <Inputs.Button variant='default'>Default 2</Inputs.Button>
                  <Inputs.Button variant='default'>Default 3</Inputs.Button>
                  <Inputs.Button variant='default'>Default 4</Inputs.Button>
                </div>
              </div>
              <div className='mt-2'>
                <div className='btn-group'>
                  <Inputs.Button variant='app'>App</Inputs.Button>
                  <Inputs.Button variant='success'>Success</Inputs.Button>
                  <Inputs.Button variant='danger'>Danger</Inputs.Button>
                  <Inputs.Button variant='warning'>Warning</Inputs.Button>
                  <Inputs.Button variant='info'>Info</Inputs.Button>
                  <Inputs.Button variant='primary'>Primary</Inputs.Button>
                  <Inputs.Button variant='secondary'>Secondary</Inputs.Button>
                  <Inputs.Button variant='default'>Default</Inputs.Button>
                </div>
              </div>
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Checkboxes</Panel.Header>
            <Panel.Body>
              <h4>Normal</h4>
              <div className='row'>
                <div className='col-4 d-flex flex-column'>
                  <Inputs.Checkbox label='Normal' checked={true} />
                  <Inputs.Checkbox label='App' variant='app' checked={true} />
                  <Inputs.Checkbox label='Success' variant='success' checked={true} />
                  <Inputs.Checkbox label='Danger' variant='danger' checked={true} />
                  <Inputs.Checkbox label='Warning' variant='warning' checked={true} />
                  <Inputs.Checkbox label='Info' variant='info' checked={true} />
                  <Inputs.Checkbox label='Primary' variant='primary' checked={true} />
                  <Inputs.Checkbox label='Secondary' variant='secondary' checked={true} />
                  <Inputs.Checkbox label='Default' variant='default' checked={true} />
                </div>
                <div className='col-4 d-flex flex-column'>
                  <Inputs.Checkbox label='Normal' indeterminate={true} />
                  <Inputs.Checkbox label='App' variant='app' indeterminate={true} />
                  <Inputs.Checkbox label='Success' variant='success' indeterminate={true} />
                  <Inputs.Checkbox label='Danger' variant='danger' indeterminate={true} />
                  <Inputs.Checkbox label='Warning' variant='warning' indeterminate={true} />
                  <Inputs.Checkbox label='Info' variant='info' indeterminate={true} />
                  <Inputs.Checkbox label='Primary' variant='primary' indeterminate={true} />
                  <Inputs.Checkbox label='Secondary' variant='secondary' indeterminate={true} />
                  <Inputs.Checkbox label='Default' variant='default' indeterminate={true} />
                </div>
                <div className='col-4 d-flex flex-column'>
                  <Inputs.Checkbox label='Normal' />
                  <Inputs.Checkbox label='App' variant='app' />
                  <Inputs.Checkbox label='Success' variant='success' />
                  <Inputs.Checkbox label='Danger' variant='danger' />
                  <Inputs.Checkbox label='Warning' variant='warning' />
                  <Inputs.Checkbox label='Info' variant='info' />
                  <Inputs.Checkbox label='Primary' variant='primary' />
                  <Inputs.Checkbox label='Secondary' variant='secondary' />
                  <Inputs.Checkbox label='Default' variant='default' />
                </div>
              </div>
            </Panel.Body>
            <Panel.Body>
              <h4>Large</h4>
              <div className='row'>
                <div className='col-4 d-flex flex-column'>
                  <Inputs.Checkbox label='Normal' size='lg' checked={true} />
                  <Inputs.Checkbox label='App' size='lg' variant='app' checked={true} />
                  <Inputs.Checkbox label='Success' size='lg' variant='success' checked={true} />
                  <Inputs.Checkbox label='Danger' size='lg' variant='danger' checked={true} />
                  <Inputs.Checkbox label='Warning' size='lg' variant='warning' checked={true} />
                  <Inputs.Checkbox label='Info' size='lg' variant='info' checked={true} />
                  <Inputs.Checkbox label='Primary' size='lg' variant='primary' checked={true} />
                  <Inputs.Checkbox label='Secondary' size='lg' variant='secondary' checked={true} />
                  <Inputs.Checkbox label='Default' size='lg' variant='default' checked={true} />
                </div>
                <div className='col-4 d-flex flex-column'>
                  <Inputs.Checkbox label='Normal' size='lg' indeterminate={true} />
                  <Inputs.Checkbox label='App' size='lg' variant='app' indeterminate={true} />
                  <Inputs.Checkbox label='Success' size='lg' variant='success' indeterminate={true} />
                  <Inputs.Checkbox label='Danger' size='lg' variant='danger' indeterminate={true} />
                  <Inputs.Checkbox label='Warning' size='lg' variant='warning' indeterminate={true} />
                  <Inputs.Checkbox label='Info' size='lg' variant='info' indeterminate={true} />
                  <Inputs.Checkbox label='Primary' size='lg' variant='primary' indeterminate={true} />
                  <Inputs.Checkbox label='Secondary' size='lg' variant='secondary' indeterminate={true} />
                  <Inputs.Checkbox label='Default' size='lg' variant='default' indeterminate={true} />
                </div>
                <div className='col-4 d-flex flex-column'>
                  <Inputs.Checkbox label='Normal' size='lg' />
                  <Inputs.Checkbox label='App' size='lg' variant='app' />
                  <Inputs.Checkbox label='Success' size='lg' variant='success' />
                  <Inputs.Checkbox label='Danger' size='lg' variant='danger' />
                  <Inputs.Checkbox label='Warning' size='lg' variant='warning' />
                  <Inputs.Checkbox label='Info' size='lg' variant='info' />
                  <Inputs.Checkbox label='Primary' size='lg' variant='primary' />
                  <Inputs.Checkbox label='Secondary' size='lg' variant='secondary' />
                  <Inputs.Checkbox label='Default' size='lg' variant='default' />
                </div>
              </div>
            </Panel.Body>
            <Panel.Body>
              <h4>Inline</h4>
              <Inputs.Checkbox label='Inline 1' checked={true} />
              <Inputs.Checkbox label='Inline 2' checked={false} />
              <Inputs.Checkbox label='Inline 3' checked={true} />
            </Panel.Body>
            <Panel.Body>
              <h4>Block</h4>
              <Inputs.Checkbox label='Block 1' checked={true} block />
              <Inputs.Checkbox label='Block 2' checked={false} block />
              <Inputs.Checkbox label='Block 3' checked={true} block />
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Radios</Panel.Header>
            <Panel.Body>
              <h4>Normal</h4>
              <div className='row'>
                <div className='col-6 d-flex flex-column'>
                  <Inputs.Radio label='Normal' checked={true} />
                  <Inputs.Radio label='App' variant='app' checked={true} />
                  <Inputs.Radio label='Success' variant='success' checked={true} />
                  <Inputs.Radio label='Danger' variant='danger' checked={true} />
                  <Inputs.Radio label='Warning' variant='warning' checked={true} />
                  <Inputs.Radio label='Info' variant='info' checked={true} />
                  <Inputs.Radio label='Primary' variant='primary' checked={true} />
                  <Inputs.Radio label='Secondary' variant='secondary' checked={true} />
                  <Inputs.Radio label='Default' variant='default' checked={true} />
                </div>
                <div className='col-6 d-flex flex-column'>
                  <Inputs.RadioGroup value='empty'>
                    <Inputs.Radio label='Normal' value='empty' checked={true} className='d-none' />
                    <Inputs.Radio label='Normal' value='1' />
                    <Inputs.Radio label='App' variant='app' value='2' />
                    <Inputs.Radio label='Success' variant='success' value='3' />
                    <Inputs.Radio label='Danger' variant='danger' value='4' />
                    <Inputs.Radio label='Warning' variant='warning' value='5' />
                    <Inputs.Radio label='Info' variant='info' value='6' />
                    <Inputs.Radio label='Primary' variant='primary' value='7' />
                    <Inputs.Radio label='Secondary' variant='secondary' value='8' />
                    <Inputs.Radio label='Default' variant='default' value='9' />
                  </Inputs.RadioGroup>
                </div>
              </div>
            </Panel.Body>
            <Panel.Body>
              <h4>Large</h4>
              <div className='row'>
                <div className='col-6 d-flex flex-column'>
                  <Inputs.Radio label='Normal' size='lg' checked={true} />
                  <Inputs.Radio label='App' size='lg' variant='app' checked={true} />
                  <Inputs.Radio label='Success' size='lg' variant='success' checked={true} />
                  <Inputs.Radio label='Danger' size='lg' variant='danger' checked={true} />
                  <Inputs.Radio label='Warning' size='lg' variant='warning' checked={true} />
                  <Inputs.Radio label='Info' size='lg' variant='info' checked={true} />
                  <Inputs.Radio label='Primary' size='lg' variant='primary' checked={true} />
                  <Inputs.Radio label='Secondary' size='lg' variant='secondary' checked={true} />
                  <Inputs.Radio label='Default' size='lg' variant='default' checked={true} />
                </div>
                <div className='col-6 d-flex flex-column'>
                  <Inputs.RadioGroup value='empty'>
                    <Inputs.Radio label='Normal' size='lg' value='empty' checked={true} className='d-none' />
                    <Inputs.Radio label='Normal' size='lg' value='1' />
                    <Inputs.Radio label='App' size='lg' variant='app' value='2' />
                    <Inputs.Radio label='Success' size='lg' variant='success' value='3' />
                    <Inputs.Radio label='Danger' size='lg' variant='danger' value='4' />
                    <Inputs.Radio label='Warning' size='lg' variant='warning' value='5' />
                    <Inputs.Radio label='Info' size='lg' variant='info' value='6' />
                    <Inputs.Radio label='Primary' size='lg' variant='primary' value='7' />
                    <Inputs.Radio label='Secondary' size='lg' variant='secondary' value='8' />
                    <Inputs.Radio label='Default' size='lg' variant='default' value='9' />
                  </Inputs.RadioGroup>
                </div>
              </div>
            </Panel.Body>
            <Panel.Body>
              <h4>Inline</h4>
              <Inputs.RadioGroup value='2'>
                <Inputs.Radio label='Inline 1' value='1' checked={true} />
                <Inputs.Radio label='Inline 2' value='2' checked={false} />
                <Inputs.Radio label='Inline 3' value='3' checked={true} />
              </Inputs.RadioGroup>
            </Panel.Body>
            <Panel.Body>
              <h4>Block</h4>
              <Inputs.RadioGroup value='2'>
                <Inputs.Radio label='Block 1' value='1' checked={true} block />
                <Inputs.Radio label='Block 2' value='2' checked={false} block />
                <Inputs.Radio label='Block 3' value='3' checked={true} block />
              </Inputs.RadioGroup>
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Spinners</Panel.Header>
            <Panel.Body>
              <h4>Circular</h4>
              <Spinner className='mr-3' animation='circular' />
              <Spinner className='mr-3' animation='circular' variant='app' />
              <Spinner className='mr-3' animation='circular' variant='success' />
              <Spinner className='mr-3' animation='circular' variant='danger' />
              <Spinner className='mr-3' animation='circular' variant='warning' />
              <Spinner className='mr-3' animation='circular' variant='info' />
              <Spinner className='mr-3' animation='circular' variant='primary' />
              <Spinner className='mr-3' animation='circular' variant='secondary' />
              <Spinner className='mr-3' animation='circular' variant='default' />
              <span className='d-inline-block bg-default mr-2'>
                <Spinner animation='circular' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-2'>
                <Spinner animation='circular' variant='white' />
              </span>
              <Spinner className='mr-3' animation='circular' variant='dark' />
              <Spinner className='mr-3' animation='circular' variant='black' />
              <Spinner className='mr-3' animation='circular' variant='rotate' />
            </Panel.Body>
            <Panel.Body>
              <h4>Circular Small</h4>
              <Spinner className='mr-3' animation='circular' size='sm' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='app' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='success' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='danger' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='warning' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='info' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='primary' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='secondary' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='circular' size='sm' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='circular' size='sm' variant='white' />
              </span>
              <Spinner className='mr-3' animation='circular' size='sm' variant='dark' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='black' />
              <Spinner className='mr-3' animation='circular' size='sm' variant='rotate' />
            </Panel.Body>
            <Panel.Body>
              <h4>Border</h4>
              <Spinner className='mr-3' animation='border' />
              <Spinner className='mr-3' animation='border' variant='app' />
              <Spinner className='mr-3' animation='border' variant='success' />
              <Spinner className='mr-3' animation='border' variant='danger' />
              <Spinner className='mr-3' animation='border' variant='warning' />
              <Spinner className='mr-3' animation='border' variant='info' />
              <Spinner className='mr-3' animation='border' variant='primary' />
              <Spinner className='mr-3' animation='border' variant='secondary' />
              <Spinner className='mr-3' animation='border' variant='default' />
              <span className='d-inline-block bg-default mr-2'>
                <Spinner animation='border' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-2'>
                <Spinner animation='border' variant='white' />
              </span>
              <Spinner className='mr-3' animation='border' variant='dark' />
              <Spinner className='mr-3' animation='border' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Border / Small</h4>
              <Spinner className='mr-3' animation='border' size='sm' />
              <Spinner className='mr-3' animation='border' size='sm' variant='app' />
              <Spinner className='mr-3' animation='border' size='sm' variant='success' />
              <Spinner className='mr-3' animation='border' size='sm' variant='danger' />
              <Spinner className='mr-3' animation='border' size='sm' variant='warning' />
              <Spinner className='mr-3' animation='border' size='sm' variant='info' />
              <Spinner className='mr-3' animation='border' size='sm' variant='primary' />
              <Spinner className='mr-3' animation='border' size='sm' variant='secondary' />
              <Spinner className='mr-3' animation='border' size='sm' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border' size='sm' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border' size='sm' variant='white' />
              </span>
              <Spinner className='mr-3' animation='border' size='sm' variant='dark' />
              <Spinner className='mr-3' animation='border' size='sm' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Border Chase</h4>
              <Spinner className='mr-3' animation='border-chase' />
              <Spinner className='mr-3' animation='border-chase' variant='app' />
              <Spinner className='mr-3' animation='border-chase' variant='success' />
              <Spinner className='mr-3' animation='border-chase' variant='danger' />
              <Spinner className='mr-3' animation='border-chase' variant='warning' />
              <Spinner className='mr-3' animation='border-chase' variant='info' />
              <Spinner className='mr-3' animation='border-chase' variant='primary' />
              <Spinner className='mr-3' animation='border-chase' variant='secondary' />
              <Spinner className='mr-3' animation='border-chase' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border-chase' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border-chase' variant='white' />
              </span>
              <Spinner className='mr-3' animation='border-chase' variant='dark' />
              <Spinner className='mr-3' animation='border-chase' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Border Chase / Small</h4>
              <Spinner className='mr-3' animation='border-chase' size='sm' />
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='app' />
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='success' />
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='danger' />
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='warning' />
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='info' />
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='primary' />
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='secondary' />
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border-chase' size='sm' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border-chase' size='sm' variant='white' />
              </span>
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='dark' />
              <Spinner className='mr-3' animation='border-chase' size='sm' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Border Swap</h4>
              <Spinner className='mr-3' animation='border-swap' />
              <Spinner className='mr-3' animation='border-swap' variant='app' />
              <Spinner className='mr-3' animation='border-swap' variant='success' />
              <Spinner className='mr-3' animation='border-swap' variant='danger' />
              <Spinner className='mr-3' animation='border-swap' variant='warning' />
              <Spinner className='mr-3' animation='border-swap' variant='info' />
              <Spinner className='mr-3' animation='border-swap' variant='primary' />
              <Spinner className='mr-3' animation='border-swap' variant='secondary' />
              <Spinner className='mr-3' animation='border-swap' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border-swap' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border-swap' variant='white' />
              </span>
              <Spinner className='mr-3' animation='border-swap' variant='dark' />
              <Spinner className='mr-3' animation='border-swap' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Border Swap / Small</h4>
              <Spinner className='mr-3' animation='border-swap' size='sm' />
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='app' />
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='success' />
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='danger' />
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='warning' />
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='info' />
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='primary' />
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='secondary' />
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border-swap' size='sm' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='border-swap' size='sm' variant='white' />
              </span>
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='dark' />
              <Spinner className='mr-3' animation='border-swap' size='sm' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Wave</h4>
              <Spinner className='mr-3' animation='wave' />
              <Spinner className='mr-3' animation='wave' variant='app' />
              <Spinner className='mr-3' animation='wave' variant='success' />
              <Spinner className='mr-3' animation='wave' variant='danger' />
              <Spinner className='mr-3' animation='wave' variant='warning' />
              <Spinner className='mr-3' animation='wave' variant='info' />
              <Spinner className='mr-3' animation='wave' variant='primary' />
              <Spinner className='mr-3' animation='wave' variant='secondary' />
              <Spinner className='mr-3' animation='wave' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='wave' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='wave' variant='white' />
              </span>
              <Spinner className='mr-3' animation='wave' variant='dark' />
              <Spinner className='mr-3' animation='wave' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Wave / Small</h4>
              <Spinner className='mr-3' animation='wave' size='sm' />
              <Spinner className='mr-3' animation='wave' size='sm' variant='app' />
              <Spinner className='mr-3' animation='wave' size='sm' variant='success' />
              <Spinner className='mr-3' animation='wave' size='sm' variant='danger' />
              <Spinner className='mr-3' animation='wave' size='sm' variant='warning' />
              <Spinner className='mr-3' animation='wave' size='sm' variant='info' />
              <Spinner className='mr-3' animation='wave' size='sm' variant='primary' />
              <Spinner className='mr-3' animation='wave' size='sm' variant='secondary' />
              <Spinner className='mr-3' animation='wave' size='sm' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='wave' size='sm' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='wave' size='sm' variant='white' />
              </span>
              <Spinner className='mr-3' animation='wave' size='sm' variant='dark' />
              <Spinner className='mr-3' animation='wave' size='sm' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Dot Chase</h4>
              <Spinner className='mr-3' animation='dot-chase' />
              <Spinner className='mr-3' animation='dot-chase' variant='app' />
              <Spinner className='mr-3' animation='dot-chase' variant='success' />
              <Spinner className='mr-3' animation='dot-chase' variant='danger' />
              <Spinner className='mr-3' animation='dot-chase' variant='warning' />
              <Spinner className='mr-3' animation='dot-chase' variant='info' />
              <Spinner className='mr-3' animation='dot-chase' variant='primary' />
              <Spinner className='mr-3' animation='dot-chase' variant='secondary' />
              <Spinner className='mr-3' animation='dot-chase' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='dot-chase' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='dot-chase' variant='white' />
              </span>
              <Spinner className='mr-3' animation='dot-chase' variant='dark' />
              <Spinner className='mr-3' animation='dot-chase' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Dot Chase / Small</h4>
              <Spinner className='mr-3' animation='dot-chase' size='sm' />
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='app' />
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='success' />
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='danger' />
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='warning' />
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='info' />
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='primary' />
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='secondary' />
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='dot-chase' size='sm' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='dot-chase' size='sm' variant='white' />
              </span>
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='dark' />
              <Spinner className='mr-3' animation='dot-chase' size='sm' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Dot Grow</h4>
              <Spinner className='mr-3' animation='dot-grow' />
              <Spinner className='mr-3' animation='dot-grow' variant='app' />
              <Spinner className='mr-3' animation='dot-grow' variant='success' />
              <Spinner className='mr-3' animation='dot-grow' variant='danger' />
              <Spinner className='mr-3' animation='dot-grow' variant='warning' />
              <Spinner className='mr-3' animation='dot-grow' variant='info' />
              <Spinner className='mr-3' animation='dot-grow' variant='primary' />
              <Spinner className='mr-3' animation='dot-grow' variant='secondary' />
              <Spinner className='mr-3' animation='dot-grow' variant='default' />
              <span className='d-inline-block bg-default mr-2'>
                <Spinner animation='dot-grow' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-2'>
                <Spinner animation='dot-grow' variant='white' />
              </span>
              <Spinner className='mr-3' animation='dot-grow' variant='dark' />
              <Spinner className='mr-3' animation='dot-grow' variant='black' />
            </Panel.Body>
            <Panel.Body>
              <h4>Dot Grow / Small</h4>
              <Spinner className='mr-3' animation='dot-grow' size='sm' />
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='app' />
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='success' />
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='danger' />
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='warning' />
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='info' />
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='primary' />
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='secondary' />
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='default' />
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='dot-grow' size='sm' variant='light' />
              </span>
              <span className='d-inline-block bg-default mr-3'>
                <Spinner animation='dot-grow' size='sm' variant='white' />
              </span>
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='dark' />
              <Spinner className='mr-3' animation='dot-grow' size='sm' variant='black' />
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Tabs</Panel.Header>
            <Panel.Body>
              <Tabs className='mt-2' defaultSelection='0'>
                <Tab title='Normal' value='0'>Normal</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' variant='app'>
                <Tab title='App' value='0'>App</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' variant='success'>
                <Tab title='Success' value='0'>Success</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' variant='danger'>
                <Tab title='Danger' value='0'>Danger</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' variant='warning'>
                <Tab title='Warning' value='0'>Warning</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' variant='info'>
                <Tab title='Info' value='0'>Info</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' variant='primary'>
                <Tab title='Primary' value='0'>Primary</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' variant='secondary'>
                <Tab title='Secondary' value='0'>Secondary</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' variant='default'>
                <Tab title='Default' value='0'>Default</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' disabled>
                <Tab title='Disabled' value='0'>Disabled</Tab>
                <Tab title='One' value='1'>One</Tab>
                <Tab title='Two' value='2'>Two</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0'>
                <Tab title='Normal' value='0'>Normal</Tab>
                <Tab title='Active' value='1'>Active</Tab>
                <Tab title='Disabled' value='2' disabled>Disabled</Tab>
              </Tabs>
              <Tabs className='mt-2' defaultSelection='0' fill>
                <Tab title='Fill Normal' value='0'>Normal</Tab>
                <Tab title='Fill One' value='1'>One</Tab>
                <Tab title='Fill Two' value='2'>Two</Tab>
              </Tabs>
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Cards</Panel.Header>
            <Panel.Body>
              <div className='card card-body'>Normal</div>
              <div className='card card-body card-light-app mt-2'>App</div>
              <div className='card card-body card-light-success mt-2'>Success</div>
              <div className='card card-body card-light-danger mt-2'>Danger</div>
              <div className='card card-body card-light-warning mt-2'>Warning</div>
              <div className='card card-body card-light-info mt-2'>Info</div>
              <div className='card card-body card-light-primary mt-2'>Primary</div>
              <div className='card card-body card-light-secondary mt-2'>Secondary</div>
              <div className='card card-body card-light-default mt-2'>Default</div>
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Alerts</Panel.Header>
            <Panel.Body>
              <div className='alert'>
                <div className='alert-heading h4' onClick={() => ShowNotify('Normal', null)}>Normal</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-app mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('App', 'app')}>App</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-success mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('It Worked!', 'success')}>Success</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-danger mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('Failure', 'danger')}>Danger</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-warning mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('Warning', 'warning')}>Warning</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-info mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('Notice', 'info')}>Info</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-primary mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('Primary', 'primary')}>Primary</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-secondary mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('Secondary', 'secondary')}>Secondary</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-default mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('Default', 'default')}>Default</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-light mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('Light', 'light')}>Light</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
              <div className='alert alert-dark mt-2'>
                <div className='alert-heading h4' onClick={() => ShowNotify('Dark', 'dark')}>Dark</div>
                <div>
                  Aww yeah, you successfully read this important alert message. This example
                  text is going to run a bit longer so that you can see how spacing within an
                  alert works with this kind of content.
                </div>
                <hr />
                <div>
                  Whenever you need to, be sure to use margin utilities to keep things nice
                  and tidy.
                </div>
              </div>
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Normal</Panel.Header>
            <Panel.Body>Normal</Panel.Body>
            <Panel.Footer>Normal</Panel.Footer>
          </Panel>

          <Panel border>
            <Panel.Header>Bordered</Panel.Header>
            <Panel.Body>Bordered</Panel.Body>
            <Panel.Footer>Bordered</Panel.Footer>
          </Panel>

          <Panel variant='default' border>
            <Panel.Header>Default</Panel.Header>
            <Panel.Body>Default</Panel.Body>
            <Panel.Footer>Default</Panel.Footer>
          </Panel>

          <Panel variant='app'>
            <Panel.Header>App</Panel.Header>
            <Panel.Body>App</Panel.Body>
            <Panel.Footer>App</Panel.Footer>
          </Panel>

          <Panel variant='success'>
            <Panel.Header>Success</Panel.Header>
            <Panel.Body>Success</Panel.Body>
            <Panel.Footer>Success</Panel.Footer>
          </Panel>

          <Panel variant='danger'>
            <Panel.Header>Danger</Panel.Header>
            <Panel.Body>Danger</Panel.Body>
            <Panel.Footer>Danger</Panel.Footer>
          </Panel>

          <Panel variant='warning'>
            <Panel.Header>Warning</Panel.Header>
            <Panel.Body>Warning</Panel.Body>
            <Panel.Footer>Warning</Panel.Footer>
          </Panel>

          <Panel variant='info'>
            <Panel.Header>Info</Panel.Header>
            <Panel.Body>Info</Panel.Body>
            <Panel.Footer>Info</Panel.Footer>
          </Panel>

          <Panel variant='primary'>
            <Panel.Header>Primary</Panel.Header>
            <Panel.Body>Primary</Panel.Body>
            <Panel.Footer>Primary</Panel.Footer>
          </Panel>

          <Panel variant='secondary'>
            <Panel.Header>Secondary</Panel.Header>
            <Panel.Body>Secondary</Panel.Body>
            <Panel.Footer>Secondary</Panel.Footer>
          </Panel>

          <Panel variant='light-app'>
            <Panel.Header>Light App</Panel.Header>
            <Panel.Body>Light App</Panel.Body>
            <Panel.Footer>Light App</Panel.Footer>
          </Panel>

          <Panel variant='light-success'>
            <Panel.Header>Light Success</Panel.Header>
            <Panel.Body>Light Success</Panel.Body>
            <Panel.Footer>Light Success</Panel.Footer>
          </Panel>

          <Panel variant='light-danger'>
            <Panel.Header>Light Danger</Panel.Header>
            <Panel.Body>Light Danger</Panel.Body>
            <Panel.Footer>Light Danger</Panel.Footer>
          </Panel>

          <Panel variant='light-warning'>
            <Panel.Header>Light Warning</Panel.Header>
            <Panel.Body>Light Warning</Panel.Body>
            <Panel.Footer>Light Warning</Panel.Footer>
          </Panel>

          <Panel variant='light-info'>
            <Panel.Header>Light Info</Panel.Header>
            <Panel.Body>Light Info</Panel.Body>
            <Panel.Footer>Light Info</Panel.Footer>
          </Panel>

          <Panel variant='light-primary'>
            <Panel.Header>Light Primary</Panel.Header>
            <Panel.Body>Light Primary</Panel.Body>
            <Panel.Footer>Light Primary</Panel.Footer>
          </Panel>

          <Panel variant='light-secondary'>
            <Panel.Header>Light Secondary</Panel.Header>
            <Panel.Body>Light Secondary</Panel.Body>
            <Panel.Footer>Light Secondary</Panel.Footer>
          </Panel>

          <Panel>
            <Panel.SkeletonHeader width={200} />
            <Panel.SkeletonBody />
            <Panel.SkeletonFooter width={250} />
          </Panel>

          <div>
            TODO
            <ol>
            </ol>
          </div>

        </div>
      </div>
    </>
  );
}